import CustomList from "components/list/custom";
import { AmountCell2 } from "@/modules/work/billables/cells";
import { Link } from "react-router-dom";
import { createFilteredUrl } from "@/hooks/useUrlState";

export function Receivables() {
  const columns = [
    {
      accessorKey: "company",
      header: "Company",
      cell: ({ getValue, row }) => {
        const companyId = row.original.company_id;

        const baseFilters = {
          contacts: {
            projects: {
              jobs: {
                billables: {
                  status: { _eq: "billed" },
                },
              },
            },
          },
          id: { _eq: companyId },
          deep: {
            contacts: {
              _filter: {
                projects: {
                  jobs: {
                    billables: {
                      status: { _eq: "billed" },
                    },
                  },
                },
              },
              projects: {
                _filter: {
                  jobs: {
                    billables: {
                      status: { _eq: "billed" },
                    },
                  },
                },
                jobs: {
                  _filter: {
                    billables: {
                      status: { _eq: "billed" },
                    },
                  },
                  billables: {
                    _filter: {
                      status: { _eq: "billed" },
                    },
                  },
                },
              },
            },
          },
        };

        return (
          <Link
            className="hover:underline"
            to={createFilteredUrl("../status/billed", baseFilters)}
            target="_blank"
            rel="noopener noreferrer"
          >
            {getValue()}
          </Link>
        );
      },
    },
    {
      accessorKey: "amount",
      header: "Overdue Amount",
      cell: AmountCell2,
    },
  ];
  return (
    <CustomList
      title="Top outstanding receivables"
      info="Top 5 companies with the highest total pending amount, the sum of their all billables."
      endPoint="custom-ui/get-top-outstanding-receivables"
      columns={columns}
      hidePagination={true}
    />
  );
}
